import InputColorPicker from "./input-color-picker";

export default InputColorPicker;